import { render } from "./BattlesGameElement.vue?vue&type=template&id=da9609a6&scoped=true"
import script from "./BattlesGameElement.vue?vue&type=script&lang=js"
export * from "./BattlesGameElement.vue?vue&type=script&lang=js"

import "./BattlesGameElement.vue?vue&type=style&index=0&id=da9609a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9609a6"]])

export default __exports__